export enum MediaEnum {
  Video = "video",
  Photo = "photo",
}
